import React from 'react';

const CardSuccessDanger = ({ valid, success, danger }) => {
    return (
        <>
            {valid ?
                <div className="card-container-success">
                    {success}
                </div>
                :
                <div className="card-container-danger">
                    {danger}
                </div>}
        </>
    );
};

export default CardSuccessDanger;
